import { api } from '../../../shared/api/client';

export const getConfigures = () => api.get('configure/getConfigures');
export const updateConfigures = (data) => api.post('configure/updateConfigures', data);

export const checkAllProxies = () => api.post('proxy/checkAllProxies', {});
export const checkProxy = (id) => api.post('proxy/checkProxy', { id });
export const createProxy = (data = {}) => api.post('proxy/createProxy', data);
export const deleteProxy = (id) => api.post('proxy/deleteProxy', { id });
export const getBanks = () => api.get('proxy/getBanks');
export const getProxies = (params = {}) => api.post('proxy/getProxies', params);
export const updateProxy = (data = {}) => api.post('proxy/updateProxy', data);

export const createWithdrawAccount = (data = {}) => api.post('withdraw-account/createWithdrawAccount', data);
export const deleteWithdrawAccount = (id) => api.post('withdraw-account/deleteWithdrawAccount', { id });
export const getBankWithdraw = () => api.get('withdraw-account/getBankWithdraw');
export const getWithdrawAccounts = (params = {}) => api.post('withdraw-account/getWithdrawAccounts', params);
export const updateWithdrawAccount = (id, params = {}) => api.post(
    'withdraw-account/updateWithdrawAccount',
    params,
    { params: { id } },
);

export const getBlockedBankList = () => api.get('blocked-banks/getListBank');
export const getBlockedBanks = (params) => api.get('blocked-banks/getBlockedBanks', { params });
export const deleteBlockedBank = (id) => api.post('blocked-banks/deleteBlockedBank', { id });
export const updateBlockedBank = (values) => api.post('blocked-banks/updateBlockedBank', values);
export const addBlockedBank = (values) => api.post('blocked-banks/addBlockedBank', values);
